module.exports = __webpack_public_path__ + "assets/9893ac78ebd32ea336ac418a327a19bc.png";